import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetBeneficiaryAddressV4,
	GetBeneficiaryAddressV4Params,
	GetBeneficiaryAddressV4Response,
} from 'domain/usecases';

export class RemoteGetBeneficiaryAddressV4 implements GetBeneficiaryAddressV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBeneficiaryAddressV4Response>,
	) {}

	async get(params: GetBeneficiaryAddressV4Params): Promise<GetBeneficiaryAddressV4Response> {
		const {signal} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
